import findGroupByKey from '@opsbase/lib-data-query/helpers/findGroupByKey';
import ViewFieldKey from '@opsbase/lib-data-viewfield/ViewFieldKey';
import useDataTree from '@opsbase/web-ctrl-datatree/useDataTree';
import useView from '@opsbase/web-ctrl-view/useView';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import flatten from 'lodash/flatten';
import React from 'react';
import useReportCSS from '../useReportCSS';
import ViewReportDataTableCell from './ViewReportDataTableCell';
const fieldsInARow = 4;
function arrayChunk(array, chunkSize) {
    return flatten(array.map((elem, i) => {
        return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
    }));
}
export function ViewReportDataTableGroup(props) {
    var _a, _b, _c, _d;
    const { nodeKey } = props;
    const dt = useDataTree();
    const node = dt.nodesByKey.get(nodeKey);
    const myCss = useReportCSS(true);
    const { fields, groupBys, maxVisibleFields } = useView(dt.viewId);
    const visibleFields = fields
        .filter(field => !field.hidden)
        .filter(field => !findGroupByKey(groupBys, field.key.toString()))
        .slice(0, maxVisibleFields);
    const firstField = visibleFields.splice(0, 1)[0];
    const fieldChunks = arrayChunk(visibleFields, fieldsInARow);
    const inlineTitles = visibleFields.length > fieldsInARow * 2;
    if (!((_b = (_a = node.itemCollection) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length))
        return null;
    return (React.createElement("div", { className: myCss.page2 },
        React.createElement(Vertical, { gutter: true, padding: true },
            React.createElement(Pane, null,
                React.createElement("div", { className: myCss.heading1nomargin }, (_c = node.group) === null || _c === void 0 ? void 0 : _c.title)),
            React.createElement(Pane, null,
                React.createElement(React.Fragment, null,
                    React.createElement("table", { className: myCss.table },
                        React.createElement("tbody", null, !inlineTitles &&
                            fieldChunks.map((fieldChunk, idx) => (React.createElement("tr", { key: 'row' + idx, className: myCss.row },
                                idx === 0 && (React.createElement("th", { rowSpan: fieldChunks.length, className: myCss.heading }, firstField.label)),
                                fieldChunk.map((field, idx2) => {
                                    const colSpan = fieldChunk.length < fieldsInARow
                                        ? idx2 === fieldChunk.length - 1
                                            ? fieldsInARow - idx2
                                            : 1
                                        : 1;
                                    return (React.createElement("th", { key: field.key + field.propertyName, colSpan: colSpan, className: myCss.heading }, field.label));
                                })))))), (_d = node.itemCollection) === null || _d === void 0 ? void 0 :
                    _d.items.slice(0, 20).map((item, rowIdx) => (React.createElement("table", { key: 'row' + rowIdx, className: myCss.table },
                        React.createElement("tbody", null, fieldChunks.map((fieldChunk, colIdx) => (React.createElement("tr", { key: item.id + colIdx, className: myCss.row },
                            colIdx === 0 &&
                                firstField.key !== ViewFieldKey.ROWKEY && (React.createElement(ViewReportDataTableCell, { item: item, field: firstField, colIdx: colIdx, rowIdx: rowIdx + 1, rowSpan: fieldChunks.length })),
                            fieldChunk.map((field, colIdx2) => {
                                const colSpan = fieldChunk.length < fieldsInARow
                                    ? colIdx2 === fieldChunk.length - 1
                                        ? fieldsInARow - colIdx2
                                        : 1
                                    : 1;
                                return (React.createElement(ViewReportDataTableCell, { key: 'cell' + colIdx2, item: item, field: field, colSpan: colSpan, colIdx: colIdx2, rowIdx: rowIdx + 1, inlineTitles: inlineTitles }));
                            })))))))))))));
}
export default ViewReportDataTableGroup;
